import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";

// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Ensure correct backend URL

// LOCAL
//axios.defaults.baseURL = 'http://localhost:8003'

// vulnapp
// axios.defaults.baseURL = "https://jobportal.vulnapp.id";
// axios.defaults.baseURL = "https://restructuring-city-set-screensavers.trycloudflare.com";


axios.defaults.withCredentials = true;

// Add request interceptor to ensure credentials
axios.interceptors.request.use((config) => {
  config.withCredentials = true;
  return config;
});

const app = createApp(App);

// Add error handler
app.config.errorHandler = (err, instance, info) => {
  console.error("Vue Error:", err);
  console.error("Component:", instance);
  console.error("Info:", info);
};

// Add router error handling
router.onError((error) => {
  console.error("Router Error:", error);
});

// Debug router
router.beforeEach((to, from, next) => {
  console.log("Navigating to:", to.path);
  next();
});

app.config.globalProperties.$http = axios;
app.use(router);
app.mount("#app");

// TODO: Internal Admin feature. Uncomment when ready to integrate.
/*
async function adminDeleteUser(userId) {
  try {
    const response = await axios.post(`/api/user/${userId}/delete`);
    console.log('User deleted via internal api:', response.data);
  } catch (err) {
    console.error('Failed to forcefully remove user. Keep this endpoint hidden!', err);
  }
}
*/
